// frontend/src/components/common/DialogHeading.jsx
//
// The text of a popup's title bar when the popup is about one record: the
// title, and under it the record's name. The name is data, so it keeps its
// own spelling instead of the bar's capitals (styles/dialog-form.css,
// "Subtitle"). It takes the bar's free width, so a close button after it
// sits at the right edge.

export default function DialogHeading({ title, subtitle = null }) {
  return (
    <span className="dialog-form-heading">
      <span>{title}</span>
      {subtitle != null && <span className="dialog-form-subtitle">{subtitle}</span>}
    </span>
  );
}
